import ViewQuizLayout from 'components/ViewQuiz/ViewQuizLayout';

const Mobile = (props) => <ViewQuizLayout device={'mobile'} {...props} />;

export default Mobile;
